import { Theme } from '@emotion/react'
import { useMediaQuery } from '@react-hook/media-query'

export const breakpoints = [320, 1024, 1440, 1920]
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72]
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const space = [0, 4, 8, 16, 32, 64, 128, 256, 512]
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const mediaQueries = {
  small: `@media screen and (min-width: ${breakpoints[0]}px)`,
  smallPortrait: `@media screen and (max-width: ${breakpoints[1]}px) and (orientation: portrait)`,
  medium: `@media screen and (min-width: ${breakpoints[1]}px)`,
  large: `@media screen and (min-width: ${breakpoints[2]}px)`,
  big: `@media screen and (min-width: ${breakpoints[3]}px)`,
}

type Breakpoints = 'small' | 'medium' | 'large' | 'big'

// Создаем собственные хуки breakpoint используя @react-hook/media-query
export const useBreakpoint = (): Breakpoints => {
  const isMedium = useMediaQuery(`(min-width: ${breakpoints[1]}px)`)
  const isLarge = useMediaQuery(`(min-width: ${breakpoints[2]}px)`)
  const isBig = useMediaQuery(`(min-width: ${breakpoints[3]}px)`)

  if (isBig) return 'big'
  if (isLarge) return 'large'
  if (isMedium) return 'medium'
  return 'small'
}

export const rpBreakPoints = [620, 1024, 1280]

export type RpBreakpoints = 'mobile' | 'tablet' | 'desktop'

export const useRpBreakpoint = (): RpBreakpoints => {
  const isTablet = useMediaQuery(`(min-width: ${rpBreakPoints[1]}px)`)
  const isDesktop = useMediaQuery(`(min-width: ${rpBreakPoints[2]}px)`)

  if (isDesktop) return 'desktop'
  if (isTablet) return 'tablet'
  return 'mobile'
}

export const rpMediaQueries = {
  mobile: `@media screen and (min-width: ${rpBreakPoints[0]}px)`,
  tablet: `@media screen and (min-width: ${rpBreakPoints[1]}px)`,
  desktop: `@media screen and (min-width: ${rpBreakPoints[2]}px)`,
}

export const maxContainerWidth = '1060px'

export const theme: Theme = {
  colors: {
    var1: '#fff',
    var2: '#121722',
    var3: '#ff9a3d',
    error: '#FF4646',
  },
  borderRadius: 4,
  rpTheme: {
    colors: {
      white: '#fff',
      gold1: '#FFC445',
      gold3: '#B29B6A',
      black: '#000',
      green: '#8BE589',
      red: '#EF0048',
    },
    typography: {
      top: {
        fontSize: {
          mobile: '10px',
          tablet: '14px',
          desktop: '14px',
        },
        fontWeight: 400,
      },
      text3: {
        fontSize: {
          mobile: '9px',
          tablet: '17px',
          desktop: '17px',
        },
        fontWeight: 400,
      },
      text4: {
        fontSize: {
          mobile: '7px',
          tablet: '13px',
          desktop: '13px',
        },
        fontWeight: 400,
      },
      text5: {
        fontSize: {
          mobile: '6px',
          tablet: '11px',
          desktop: '11px',
        },
        fontWeight: 500,
      },
      buttonLittle: {
        fontSize: {
          mobile: '6px',
          tablet: '11px',
          desktop: '11px',
        },
        fontWeight: 500,
      },
      decisionBtn: {
        fontSize: {
          mobile: '10px',
          tablet: '14px',
          desktop: '16px',
        },
        fontWeight: 500,
      },
      buttonBig: {
        fontSize: {
          mobile: '9px',
          tablet: '19px',
          desktop: '19px',
        },
        fontWeight: 500,
      },
      buttonSmall: {
        fontSize: {
          mobile: '9px',
          tablet: '17px',
          desktop: '17px',
        },
        fontWeight: 400,
      },
      head1: {
        fontSize: {
          mobile: '12px',
          tablet: '22px',
          desktop: '22px',
        },
        fontWeight: 600,
      },
      head2: {
        fontSize: {
          mobile: '7px',
          tablet: '13px',
          desktop: '13px',
        },
        fontWeight: 600,
      },
      head3: {
        fontSize: {
          mobile: '9px',
          tablet: '16px',
          desktop: '18px',
        },
        fontWeight: 500,
      },
      titleBig: {
        fontSize: {
          mobile: '5px',
          tablet: '9px',
          desktop: '9px',
        },
        fontWeight: 500,
      },
      title: {
        fontSize: {
          mobile: '4px',
          tablet: '7px',
          desktop: '7px',
        },
        fontWeight: 500,
      },
      dealerTitle: {
        fontSize: {
          mobile: '6px',
          tablet: '12px',
          desktop: '14px',
        },
        fontWeight: 500,
      },
      gameInfo: {
        fontSize: {
          mobile: '6px',
          tablet: '11px',
          desktop: '11px',
        },
        fontWeight: 500,
      },
      win: {
        fontSize: {
          mobile: '8px',
          tablet: '15px',
          desktop: '15px',
        },
        fontWeight: 600,
      },
      dealer: {
        fontSize: {
          mobile: '7px',
          tablet: '14px',
          desktop: '16px',
        },
        fontWeight: 600,
      },
      yellowBtn: {
        fontSize: {
          mobile: '8px',
          tablet: '14px',
          desktop: '16px',
        },
        fontWeight: 400,
      },
    },
  },
}
